import { getAuth } from 'firebase/auth';
import HttpClient from '../../../core/HttpClient';

interface ApiKeyResult {
  success: boolean;
  error?: string;
  apiKey?: string;
}

/**
 * Generate a new REST API key for the authenticated user.
 * The key is returned only once — it will not be shown again.
 */
export const generateApiKey = async (): Promise<ApiKeyResult> => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return { success: false, error: 'Aucun utilisateur connecté' };
    }

    const idToken = await currentUser.getIdToken();

    const response = await HttpClient.post(
      '/user/api-key',
      {},
      idToken,
    );

    return { success: true, apiKey: response.data.api_key as string };
  } catch (e: any) {
    console.error('generateApiKey error:', e);
    return { success: false, error: e?.message || "Erreur lors de la génération de la clé API" };
  }
};

/**
 * Revoke (disable) the authenticated user's REST API key.
 */
export const revokeApiKey = async (): Promise<ApiKeyResult> => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return { success: false, error: 'Aucun utilisateur connecté' };
    }

    const idToken = await currentUser.getIdToken();

    await HttpClient.delete(
      '/user/api-key',
      {},
      idToken,
    );

    return { success: true };
  } catch (e: any) {
    console.error('revokeApiKey error:', e);
    return { success: false, error: e?.message || "Erreur lors de la révocation de la clé API" };
  }
};
